export default __webpack_public_path__ + "static/media/10.948674a3.jpg";